<template>
  <div v-if="isLoaded" class="page-container" data-test="main-holder">
    <Header></Header>
    <router-view />
    <mc-loading-indicator
      v-if="isNavigating"
      class="fixed inset-0 z-[100] grid place-items-center bg-white/75"
      fit="medium"
      label="Loading..."
    />
    <Footer></Footer>
    <CopilotChatWidget v-if="copilotFeatureFlag" />
  </div>
  <mc-loading-indicator v-else class="start-loading" fit="medium" label="Initializing authentication..." />
</template>

<script setup lang="ts">
import "@maersk-global/mds-components-core/mc-loading-indicator";
import { defineAsyncComponent, inject, ref, type Ref } from "vue";
import Header from "@/layout/Header.vue";
import Footer from "@/layout/Footer.vue";
import { isNavigating } from "@/modules/navigation/routeLoading";
import { rumInit } from "@/config/rumConfig";
import { getEnvConfig } from "@/config/envConfig";

const CopilotChatWidget = defineAsyncComponent(() => import("@/components/copilotStudio/CopilotChatWidget.vue"));
const copilotFeatureFlag = String(getEnvConfig().copilotStudioFeatureFlag).trim().toLowerCase() === "true";
const isLoaded = inject<Ref<boolean>>("isLoaded", ref(false));

//Real User Monitoring - https://docs.mop.maersk.io/rum/index.html
rumInit();
</script>

<style scoped lang="scss">
.page-container {
  position: relative;
  margin: 0;
  max-width: 100%;
}

.start-loading {
  min-height: 100vh;
  display: grid;
  place-items: center;
}
</style>
